import { CheckCaptchaResponse } from 'api/evisaAPI/auth'
import { CallAPIAction, Status } from 'api/types'
import Actions from 'redux/actions'

type State = {
  maxAttempt: boolean
} & Status

const initialState = {
  maxAttempt: false,
  isLoading: false,
  success: false,
  fail: false,
}

export default (
  state = initialState,
  action: CallAPIAction<
    Actions.CHECK_CAPTCHA_ASYNC,
    Actions.CHECK_CAPTCHA_SUCCESS,
    Actions.CHECK_CAPTCHA_FAIL,
    CheckCaptchaResponse
  >,
): State => {
  switch (action.type) {
    case Actions.CHECK_CAPTCHA_FAIL:
    case Actions.CHECK_CAPTCHA_ASYNC:
      return {
        ...state,
        ...action.status,
      }
    case Actions.CHECK_CAPTCHA_SUCCESS: {
      const { payload } = action
      return {
        ...state,
        maxAttempt: payload.max_attempt,
        ...action.status,
      }
    }
    default:
      return state
  }
}
